<template>
    <el-dialog v-model="dialogOpened" @close="resetUser" :bind="$attrs" @open="resetUser" :title="dialogTitle">
        <EditUserForm v-model="currentUser" @save="saveUser" @cancel="closeDialog" enable-roles />
    </el-dialog>
</template>

<script>
import api from '@/lib/api'
import {mapGetters} from 'vuex'

import EditUserForm from '@/components/user/EditUserForm.vue'

export default {
    name: 'CreateUserDialog',

    components: { EditUserForm },

    emits: ['update:dialog', 'created', 'edited'],

    props: {
        dialog: { type: Boolean, required: true },
        user: { type: Object, default: () => ({enabled: true}) }
    },

    watch: {
        user (value) { this.currentUser = {...value} }
    },

    computed: {
        ...mapGetters('auth', ['userinfo']),

        dialogOpened: {
            get() { return this.dialog },
            set(value) { this.$emit('update:dialog', value) }
        },

        dialogTitle () {
            return this.user.id ? 'Edit user' : 'Create user'
        }
    },

    data: () => ({
        currentUser: {enabled: true}
    }),

    methods: {
        closeDialog () {
            this.dialogOpened = false
        },

        resetUser () {
            this.currentUser = {...this.user}
        },

        saveUser () {
            if (this.currentUser.id) {
                this.editUser( this.currentUser )
            } else {
                this.addUser( this.currentUser )
            }
        },

        editUser (user) {
            api.user.editUser (user.id, {...user}).then(response => {
                this.$notify({
                    title: 'Success',
                    message: `User profile saved`,
                    type: 'success'
                })

                api.user.editUserRoles(user.id, user.roles).then(() => {
                    this.$notify({
                        title: 'Success',
                        message: `User roles saved`,
                        type: 'success'
                    })
                })

                if (user.id === this.userinfo.id) {
                    api.auth.refreshUserinfo()
                }

                this.$emit('edited', response.data)
                this.closeDialog()
            }).catch(error => {
                const err = error?.response?.data?.message || error.message

                console.error (error)

                this.$notify({
                    title: 'Error',
                    message: `Could not save user information: ${err}`,
                    type: 'error'
                })
            })
        },
        addUser (user) {
            api.user.postUser (user).then(response => {
                this.$notify({
                    title: 'Success',
                    message: `User created`,
                    type: 'success'
                })

                this.$emit('created', response.data)
                this.closeDialog()
            }).catch(error => {
                const err = error?.response?.data?.message || error.message

                this.$notify({
                    title: 'Error',
                    message: `Could not create user: ${err}`,
                    type: 'error'
                })
            })
        },
    },

    mounted () {
        this.resetUser()
    }
}
</script>